import { Box } from '../Box/Box';

export function SearchOptionsSeparator() {
  return <Box py="sp-2" />;
}
